import Schedule from "@/types/Schedule.interface"

interface State {
    schedules: Schedule[]
}

//  As of 2023-02-22, we do not use schedules
const defaults = () => {
    return {
        schedules: []
    }
}

export default {
    state: defaults(),
    mutations: {
        schedulesPush (state: State, schedules: Schedule[]): void {
            state.schedules = window.removeDuplicatesById(state.schedules, schedules)
        },
        schedulesRemove (state: State, ids: number[]): void {
            //  Get our global list of schedules
            const schedules = state.schedules

            //  If no schedules, do nothing
            if (!schedules) return

            //  Else, filter out our removed ids
            const filtered = schedules.filter((x: Schedule) => !ids.includes(x.id))

            //  Replace our list with the filtered list
            state.schedules = filtered
        },
        schedulesReset (state: State): void {
            Object.assign(state, defaults())
        },
        schedulesSet (state: State, schedules: Schedule[]): void {
            state.schedules = schedules
        }
    },
    actions: {
        schedulesPause ({ commit, getters }, scheduleId: number): Promise<Schedule> {
            //  Assemble the API endpoint
            const url = `${getters.api}/schedule/${scheduleId}/pause`

            //  Send the request
            return window.axios.post(url).then(response => {
                //  Update our global dataset
                commit('schedulesPush', [response.data])

                //  Return our paused schedule
                return response.data
            }).catch(() => null)
        },
        schedulesPost ({ commit, dispatch, getters }, schedule: Schedule): Promise<Schedule> {
            //  Get the current subscription
            const sub = getters.subscription

            //  If the user is past due then don't allow
            if (sub.status === 'past_due') {
                //  Pop a dialog informing the user
                dispatch('dialogPastDue')
                //  Return null because this failed
                return null
            }

            //  Assemble the API endpoint
            const url = `${getters.api}/schedule`

            //  Send the request
            return window.axios.post(url, schedule).then(response => {
                //  Update our global dataset
                commit('schedulesPush', [response.data])

                //  Return our new schedule
                return response.data
            }).catch(e => console.error("SchedulesPost ERROR", e))
        },
        schedulesPut ({ commit, getters }, schedule: Schedule): Promise<Schedule> {
            //  Assemble the API endpoint
            const url = `${getters.api}/schedule`

            //  Send the request
            return window.axios.put(url, schedule).then(response => {
                //  Update our global dataset
                commit('schedulesPush', [response.data])

                //  Return our new schedule
                return response.data
            }).catch(() => null)
        },
        schedulesResume ({ commit, getters }, scheduleId: number): Promise<Schedule> {
            //  Assemble the API endpoint
            const url = `${getters.api}/schedule/${scheduleId}/resume`

            //  Send the request
            return window.axios.post(url).then(response => {
                //  Update our global dataset
                commit('schedulesPush', [response.data])

                //  Return our resumed schedule
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        schedules (state: State): Schedule[] {
            return state.schedules
        }
    }
}
